import { FilterMatchMode } from "primereact/api"

export class Proceso {
    constructor(siFilter) {
        this.model = {
            id: { value: null, export: false },
            observacion: {
                value: '', export: true, header: 'Observación', required: false, maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 500, min: 3, table: false,
            },
            empresa: {
                header: 'Empresa', value: '', required: 'Empresa es requerido', optionLabel: 'empresa', export: true, table: true,
                filter: siFilter, sort: true, matchMode: FilterMatchMode.CONTAINS
            },
            tipo_proceso: {
                header: 'Tipo de proceso', value: '', required: false, optionLabel: 'tipo_proceso', export: true, table: true,
                filter: siFilter, sort: true, matchMode: FilterMatchMode.CONTAINS
            },
            tipo_ejecucion: {
                header: 'Tipo de ejecución', value: '', required: false, optionLabel: 'tipo_ejecucion', export: true, table: true,
                filter: siFilter, sort: true, matchMode: FilterMatchMode.CONTAINS
            },
            tipo_periocidad: {
                header: 'Periocidad', value: '', required: false, optionLabel: 'tipo_periocidad', export: true, table: true,
                filter: false, sort: true, matchMode: FilterMatchMode.CONTAINS
            },
            estado: {
                header: 'Estado', value: '', required: false, optionLabel: 'estado', export: true, table: true,
                filter: siFilter, sort: true, matchMode: FilterMatchMode.CONTAINS
            },
            fecha_inicio: { header: 'Fecha inicio', value: null, table: true, export: true, filter: false, matchMode: FilterMatchMode.DATE_IS, filterField: 'fecha', isDate: true, },
            fecha_fin: { header: 'Fecha fin', value: null, table: true, export: true, filter: false, matchMode: FilterMatchMode.DATE_IS, filterField: 'fecha', isDate: true, },

        }
    }

    optionLabel = 'nombre'
}
